module.exports = __webpack_public_path__ + "static/media/license.c1b8a37c.png";